<script lang="ts" setup>
import { useStyle3d } from './style3d.ts';
import type { ID, Style3dOptions } from './typing.ts';
import { onMounted, watch } from 'vue';

const props = defineProps<{
  options: Style3dOptions
}>();

const emit = defineEmits<{
  loaded: []
  ready: [ready: boolean]
  'material-selected': [id: ID|null]
}>();

const style3dInstance = useStyle3d();

watch(() => style3dInstance.isReady, (v) => {
  emit('ready', v);
});

onMounted(async () => {
  await style3dInstance.initStyle3d({
    ...props.options,
    events: {
      onMaterialSelected(selectedMaterial) {
        const { materialInfo } = selectedMaterial;
        emit('material-selected', materialInfo.id);
      },
      onNothingSelected() {
        emit('material-selected', null);
      }
    }
  })
    .then(() => {
      emit('loaded');
    });
});

const style3d = useStyle3d();
</script>

<template>
  <div class="viewer-container">
    <div class="three-con" v-show="style3d.model==='GLB'" id="glb-con" @dragover.prevent></div>
    <div class="three-con" v-show="style3d.model==='SCO'" id="style3d-con" @dragover.prevent></div>
  </div>
</template>
<style scoped>
.viewer-container .three-con {
  width: 100%;
  height: 100%;
}
</style>
